import {FC} from 'react'
import InlineSVG from 'react-inlinesvg'
import {GButton, GModal} from 'src/app/components/Libs'
import {toAbsoluteUrl} from 'src/app/utils/asset-helpers.utils'
import {cn} from 'src/app/utils/cn.utils'

const SessionModal: FC<any> = ({show, setShow, onSubmit}) => {
  return (
    <GModal
      show={show}
      onHide={() => setShow(false)}
      className={cn('w-[400px] min-h-[232px] max-h-[232px]')}
    >
      <div className='relative flex flex-col justify-between flex-1 w-full h-full p-6'>
        <div>
          <div>
            <InlineSVG src={toAbsoluteUrl('/media/image/image_warning.svg')} />
          </div>

          <div className='mt-5'>
            <div className='font-medium text-neutral-900 text-fs-7'>Sesi telah berakhir</div>
            <div className='mt-1 text-neutral-500 text-fs-9'>
              Anda akan diarahkan ke halaman login
            </div>
          </div>
        </div>

        <div className={cn('flex items-center justify-between gap-3 mt-8')}>
          <GButton type='button' className='w-full p-2 text-fs-9' onClick={onSubmit}>
            Lanjutkan
          </GButton>
        </div>
      </div>
    </GModal>
  )
}

export default SessionModal
